export const mockWidgetSettings = {
  color: '#5A98F7',
  welcomeTitle: 'Hi there!',
  widgetName: 'Chatbot',
  chatHistoryLevel: 'LOCAL_STORAGE',
  isBackgroundBlurred: false,
  isComposerInputEnabled: true,
  isLoginNameInputEnabled: false,
  isLoginEmailInputEnabled: false,
  popup_text: 'Hey there! Ready to start a journey?',
  greeting_text: 'Ready to start a journey with our chatbot?',
  logo: '/default_avatar.png',
  startButton: 'start',
  emailInputPlaceholder: 'Your email',
  nameInputPlaceholder: 'Your name',
  nameInputError: 'Username can’t contain special symbols, numbers or spaces',
  emailInputError: 'Email is not valid.',
  emailInputEmptyError: 'Email should not be blank',
  startLabel: 'Jump into the chat by entering your info',
}
